var newValidateRegExp = require('./newValidateRegExp');

module.exports = function(maxCharacters) {
	var validate = newValidateRegExp('^[a-zA-Z0-9]{0,' + maxCharacters + '}$');
	validate.message = 'Expected max ' + maxCharacters + ' characters';
	return validate;
}
